import Validation from 'utils/validation.utils';

export const initialState = (state = {}) => {
  const {
    name = {
      value: '',
      disabled: false
    },
    code = {
      value: '',
      disabled: false
    },
    accountCategoryId = {
      value: '',
      label: '',
      disabled: false
    },
    financialStatement = {
      value: '',
      disabled: false
    },
    isPostable = {
      value: false,
      disabled: false
    },
    isAffectsCashflow = {
      value: false,
      disabled: false
    },
    isCash = {
      value: false,
      disabled: false
    },
    level = {
      value: false,
      disabled: false
    },
    parentAccountId = {
      value: false,
      disabled: false
    }
  } = state;
  return {
    name: {
      name: 'name',
      validations: [Validation.required({ noMessage: true })],
      maxLength: 100,
      label: 'Name',
      required: true,
      ...name
    },
    code: {
      name: 'code',
      validations: [Validation.required({ noMessage: true })],
      maxLength: 5,
      label: 'Code',
      required: true,
      ...code
    },
    accountCategoryId: {
      name: 'accountCategoryId',
      ...accountCategoryId
    },
    financialStatement: {
      name: 'financialStatement',
      validations: [Validation.required({ noMessage: true })],
      label: 'Financial Statement',
      required: true,
      ...financialStatement
    },
    isPostable: {
      name: 'isPostable',
      ...isPostable
    },
    isAffectsCashflow: {
      name: 'isAffectsCashflow',
      ...isAffectsCashflow
    },
    isCash: {
      name: 'isCash',
      ...isCash
    },
    level: {
      name: 'level',
      ...level
    },
    parentAccountId: {
      name: 'parentAccountId',
      ...parentAccountId
    }
  };
};
